// @ts-nocheck
/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import { z as zod } from 'zod';

/**
 * Get module submission with grading information.

This endpoint allows lecturers to retrieve the module submission
with module-level grading information (feedback, grade, scores).
 * @summary Get Module Submission Evaluation
 */
export const getModuleSubmissionEvaluationParams = zod
  .object({
    user_id: zod.coerce.string(),
    course_id: zod.coerce.string(),
    module_id: zod.coerce.string(),
  })
  .strict();

export const getModuleSubmissionEvaluationResponseDataGradingConfigSnapshotEvalDimensionsMaxWeightMinOne = 0;
export const getModuleSubmissionEvaluationResponseDataGradingConfigSnapshotEvalDimensionsMaxWeightMaxOne = 1;
export const getModuleSubmissionEvaluationResponseDataGradingConfigSnapshotPerformanceLevelsItemPerformancePercentMin = 0;

export const getModuleSubmissionEvaluationResponseDataGradingConfigSnapshotPerformanceLevelsItemPerformancePercentMax = 1;
export const getModuleSubmissionEvaluationResponseDataGradingConfigSnapshotGradeProjectorFailAtMin = 0;

export const getModuleSubmissionEvaluationResponseDataGradingConfigSnapshotGradeProjectorFailAtMax = 1;
export const getModuleSubmissionEvaluationResponseDataGradingConfigSnapshotGradeProjectorTopAtMin = 0;

export const getModuleSubmissionEvaluationResponseDataGradingConfigSnapshotGradeProjectorTopAtMax = 1;
export const getModuleSubmissionEvaluationResponseDataGradingConfigSnapshotTaskGradeProjectorsFailAtMin = 0;

export const getModuleSubmissionEvaluationResponseDataGradingConfigSnapshotTaskGradeProjectorsFailAtMax = 1;
export const getModuleSubmissionEvaluationResponseDataGradingConfigSnapshotTaskGradeProjectorsTopAtMin = 0;

export const getModuleSubmissionEvaluationResponseDataGradingConfigSnapshotTaskGradeProjectorsTopAtMax = 1;

export const getModuleSubmissionEvaluationResponse = zod
  .object({
    data: zod
      .object({
        id: zod.string(),
        courseId: zod.string(),
        moduleId: zod.string(),
        moduleVersion: zod.string().or(zod.null()),
        studentId: zod.string(),
        studentName: zod.string(),
        state: zod.enum(['draft', 'processing', 'submitted', 'graded', 'aborted']),
        submittedAt: zod.string().datetime().or(zod.null()),
        gradedAt: zod.string().datetime().or(zod.null()),
        grading: zod
          .object({
            feedback: zod.string(),
            scoring: zod
              .object({
                scoringSchemaName: zod.string().or(zod.null()).optional(),
                scores: zod.record(zod.string(), zod.number()),
              })
              .strict()
              .or(zod.null())
              .optional(),
            grade: zod.number().or(zod.null()).optional(),
            manualGrade: zod.boolean().optional(),
            evaluatorId: zod.string().or(zod.null()).optional(),
          })
          .strict()
          .or(zod.null())
          .optional(),
        gradingConfigSnapshot: zod
          .object({
            evalDimensions: zod
              .record(
                zod.string(),
                zod
                  .object({
                    description: zod.string(),
                    systemManaged: zod.boolean().optional(),
                    maxWeight: zod
                      .number()
                      .min(getModuleSubmissionEvaluationResponseDataGradingConfigSnapshotEvalDimensionsMaxWeightMinOne)
                      .max(getModuleSubmissionEvaluationResponseDataGradingConfigSnapshotEvalDimensionsMaxWeightMaxOne)
                      .or(zod.null())
                      .optional(),
                  })
                  .strict(),
              )
              .optional(),
            performanceLevels: zod
              .array(
                zod
                  .object({
                    id: zod.string(),
                    performancePercent: zod
                      .number()
                      .min(
                        getModuleSubmissionEvaluationResponseDataGradingConfigSnapshotPerformanceLevelsItemPerformancePercentMin,
                      )
                      .max(
                        getModuleSubmissionEvaluationResponseDataGradingConfigSnapshotPerformanceLevelsItemPerformancePercentMax,
                      ),
                    label: zod.string(),
                    description: zod.string(),
                  })
                  .strict(),
              )
              .optional(),
            defaultFormalDimension: zod
              .object({
                name: zod.string(),
                max_pts: zod.number(),
                criteria: zod.array(
                  zod
                    .object({
                      name: zod.string(),
                      pts: zod.number(),
                      descriptor: zod.string(),
                      dimension_critical: zod.boolean().optional(),
                      active_when_all_positive: zod.array(zod.string()).optional(),
                    })
                    .strict(),
                ),
                params: zod.record(zod.string(), zod.any()).optional(),
                actual_max_pts: zod.number(),
              })
              .strict(),
            defaultFormalParams: zod
              .record(zod.string(), zod.record(zod.string(), zod.record(zod.string(), zod.any())))
              .or(zod.null())
              .optional(),
            gradeProjector: zod
              .object({
                type: zod.string().optional(),
              })
              .strict()
              .or(
                zod
                  .object({
                    type: zod.string().optional(),
                  })
                  .strict(),
              )
              .or(
                zod
                  .object({
                    type: zod.string().optional(),
                  })
                  .strict(),
              )
              .or(
                zod
                  .object({
                    type: zod.string().optional(),
                    failAt: zod
                      .number()
                      .min(getModuleSubmissionEvaluationResponseDataGradingConfigSnapshotGradeProjectorFailAtMin)
                      .max(getModuleSubmissionEvaluationResponseDataGradingConfigSnapshotGradeProjectorFailAtMax)
                      .optional(),
                    topAt: zod
                      .number()
                      .min(getModuleSubmissionEvaluationResponseDataGradingConfigSnapshotGradeProjectorTopAtMin)
                      .max(getModuleSubmissionEvaluationResponseDataGradingConfigSnapshotGradeProjectorTopAtMax)
                      .optional(),
                  })
                  .strict(),
              )
              .or(zod.null())
              .optional(),
            taskGradeProjectors: zod
              .record(
                zod.string(),
                zod
                  .object({
                    type: zod.string().optional(),
                  })
                  .strict()
                  .or(
                    zod
                      .object({
                        type: zod.string().optional(),
                      })
                      .strict(),
                  )
                  .or(
                    zod
                      .object({
                        type: zod.string().optional(),
                      })
                      .strict(),
                  )
                  .or(
                    zod
                      .object({
                        type: zod.string().optional(),
                        failAt: zod
                          .number()
                          .min(
                            getModuleSubmissionEvaluationResponseDataGradingConfigSnapshotTaskGradeProjectorsFailAtMin,
                          )
                          .max(
                            getModuleSubmissionEvaluationResponseDataGradingConfigSnapshotTaskGradeProjectorsFailAtMax,
                          )
                          .optional(),
                        topAt: zod
                          .number()
                          .min(
                            getModuleSubmissionEvaluationResponseDataGradingConfigSnapshotTaskGradeProjectorsTopAtMin,
                          )
                          .max(
                            getModuleSubmissionEvaluationResponseDataGradingConfigSnapshotTaskGradeProjectorsTopAtMax,
                          )
                          .optional(),
                      })
                      .strict(),
                  ),
              )
              .or(zod.null())
              .optional(),
          })
          .strict()
          .or(zod.null())
          .optional(),
      })
      .strict()
      .or(zod.null())
      .optional(),
    message: zod.string().or(zod.null()).optional(),
    pagination: zod
      .object({
        total: zod.number(),
        page: zod.number(),
        pageSize: zod.number(),
      })
      .strict()
      .or(zod.null())
      .optional(),
    error: zod
      .object({
        code: zod.string(),
        message: zod.string(),
        details: zod.record(zod.string(), zod.any()).or(zod.null()).optional(),
      })
      .strict()
      .or(zod.null())
      .optional(),
    statusCode: zod.number().optional(),
  })
  .strict();

/**
 * Evaluate and grade a module submission.

This endpoint allows lecturers to:
1. Update task evaluations for multiple tasks at once
2. Add module-level grading
3. Change the submission state to GRADED (only if submit_to_student is True)
4. Save evaluations as drafts without submitting to students (if submit_to_student is False)
 * @summary Evaluate Module Submission
 */
export const evaluateModuleSubmissionParams = zod
  .object({
    user_id: zod.coerce.string(),
    course_id: zod.coerce.string(),
    module_id: zod.coerce.string(),
  })
  .strict();

export const evaluateModuleSubmissionBody = zod
  .object({
    taskEvaluations: zod
      .record(
        zod.string(),
        zod
          .object({
            evaluation: zod
              .object({
                kind: zod.string().optional(),
                dimensions: zod.record(
                  zod.string(),
                  zod
                    .object({
                      level: zod.string().or(zod.null()).optional(),
                      comment: zod.string().or(zod.null()).optional(),
                      criteriaEvaluations: zod
                        .array(
                          zod
                            .object({
                              name: zod.string(),
                              met: zod.boolean(),
                            })
                            .strict(),
                        )
                        .or(zod.null())
                        .optional(),
                    })
                    .strict(),
                ),
              })
              .strict()
              .or(
                zod
                  .object({
                    kind: zod.string().optional(),
                    subEvaluations: zod.record(
                      zod.string(),
                      zod
                        .object({
                          dimGrades: zod.record(
                            zod.string(),
                            zod
                              .object({
                                level: zod.string().or(zod.null()).optional(),
                                comment: zod.string().or(zod.null()).optional(),
                                criteriaEvaluations: zod
                                  .array(
                                    zod
                                      .object({
                                        name: zod.string(),
                                        met: zod.boolean(),
                                      })
                                      .strict(),
                                  )
                                  .or(zod.null())
                                  .optional(),
                              })
                              .strict(),
                          ),
                          questionFeedback: zod.string().or(zod.null()).optional(),
                        })
                        .strict(),
                    ),
                    overallFeedback: zod
                      .object({
                        text: zod.string().or(zod.null()).optional(),
                        highlighting: zod
                          .record(
                            zod.string(),
                            zod.array(
                              zod
                                .object({
                                  start: zod.string(),
                                  end: zod.string(),
                                })
                                .strict(),
                            ),
                          )
                          .or(zod.null())
                          .optional(),
                      })
                      .strict()
                      .or(zod.null())
                      .optional(),
                    promptVersion: zod.string().or(zod.null()).optional(),
                  })
                  .strict(),
              )
              .or(zod.null())
              .optional(),
            feedback: zod
              .object({
                text: zod.string().or(zod.null()).optional(),
                highlighting: zod
                  .record(
                    zod.string(),
                    zod.array(
                      zod
                        .object({
                          start: zod.string(),
                          end: zod.string(),
                        })
                        .strict(),
                    ),
                  )
                  .or(zod.null())
                  .optional(),
              })
              .strict()
              .or(zod.null())
              .optional(),
          })
          .strict(),
      )
      .or(zod.null())
      .optional(),
    grading: zod
      .object({
        feedback: zod.string(),
        scoring: zod
          .object({
            scoringSchemaName: zod.string().or(zod.null()).optional(),
            scores: zod.record(zod.string(), zod.number()),
          })
          .strict()
          .or(zod.null())
          .optional(),
        grade: zod.number().or(zod.null()).optional(),
        manualGrade: zod.boolean().optional(),
        evaluatorId: zod.string().or(zod.null()).optional(),
      })
      .strict()
      .or(zod.null())
      .optional(),
    submitToStudent: zod.boolean().optional(),
  })
  .strict();

export const evaluateModuleSubmissionResponse = zod
  .object({
    data: zod
      .object({
        scores: zod
          .record(
            zod.string(),
            zod
              .object({
                key: zod.string(),
                label: zod.string(),
                min: zod.number().optional(),
                max: zod.number().optional(),
                weight: zod.number().or(zod.null()).optional(),
                score: zod.number(),
              })
              .strict(),
          )
          .or(zod.null())
          .optional(),
        comment: zod.string().or(zod.null()).optional(),
        grade: zod.number().or(zod.null()).optional(),
        gradedAt: zod.string().datetime().or(zod.null()).optional(),
        adminOverride: zod
          .object({
            comment: zod.string(),
          })
          .strict()
          .or(zod.null())
          .optional(),
      })
      .strict()
      .or(zod.null())
      .optional(),
    message: zod.string().or(zod.null()).optional(),
    pagination: zod
      .object({
        total: zod.number(),
        page: zod.number(),
        pageSize: zod.number(),
      })
      .strict()
      .or(zod.null())
      .optional(),
    error: zod
      .object({
        code: zod.string(),
        message: zod.string(),
        details: zod.record(zod.string(), zod.any()).or(zod.null()).optional(),
      })
      .strict()
      .or(zod.null())
      .optional(),
    statusCode: zod.number().optional(),
  })
  .strict();

/**
 * Update evaluation for a submission
 * @summary Upsert Lecturer Evaluation
 */
export const updateEvaluationParams = zod
  .object({
    user_id: zod.coerce.string(),
    course_id: zod.coerce.string(),
    module_id: zod.coerce.string(),
    task_id: zod.coerce.string(),
  })
  .strict();

export const updateEvaluationBody = zod
  .object({
    evaluation: zod
      .object({
        kind: zod.string().optional(),
        dimensions: zod.record(
          zod.string(),
          zod
            .object({
              level: zod.string().or(zod.null()).optional(),
              comment: zod.string().or(zod.null()).optional(),
              criteriaEvaluations: zod
                .array(
                  zod
                    .object({
                      name: zod.string(),
                      met: zod.boolean(),
                    })
                    .strict(),
                )
                .or(zod.null())
                .optional(),
            })
            .strict(),
        ),
      })
      .strict()
      .or(
        zod
          .object({
            kind: zod.string().optional(),
            subEvaluations: zod.record(
              zod.string(),
              zod
                .object({
                  dimGrades: zod.record(
                    zod.string(),
                    zod
                      .object({
                        level: zod.string().or(zod.null()).optional(),
                        comment: zod.string().or(zod.null()).optional(),
                        criteriaEvaluations: zod
                          .array(
                            zod
                              .object({
                                name: zod.string(),
                                met: zod.boolean(),
                              })
                              .strict(),
                          )
                          .or(zod.null())
                          .optional(),
                      })
                      .strict(),
                  ),
                  questionFeedback: zod.string().or(zod.null()).optional(),
                })
                .strict(),
            ),
            overallFeedback: zod
              .object({
                text: zod.string().or(zod.null()).optional(),
                highlighting: zod
                  .record(
                    zod.string(),
                    zod.array(
                      zod
                        .object({
                          start: zod.string(),
                          end: zod.string(),
                        })
                        .strict(),
                    ),
                  )
                  .or(zod.null())
                  .optional(),
              })
              .strict()
              .or(zod.null())
              .optional(),
            promptVersion: zod.string().or(zod.null()).optional(),
          })
          .strict(),
      )
      .or(zod.null())
      .optional(),
    feedback: zod
      .object({
        text: zod.string().or(zod.null()).optional(),
        highlighting: zod
          .record(
            zod.string(),
            zod.array(
              zod
                .object({
                  start: zod.string(),
                  end: zod.string(),
                })
                .strict(),
            ),
          )
          .or(zod.null())
          .optional(),
      })
      .strict()
      .or(zod.null())
      .optional(),
  })
  .strict();

export const updateEvaluationResponse = zod
  .object({
    data: zod
      .object({
        id: zod.string().or(zod.null()).optional(),
        taskId: zod.string().or(zod.null()).optional(),
        userId: zod.string().or(zod.null()).optional(),
        moduleId: zod.string().or(zod.null()).optional(),
        state: zod.string().optional(),
        text: zod.string().or(zod.null()).optional(),
        attachments: zod
          .array(
            zod
              .object({
                id: zod.string(),
                taskId: zod.string().optional(),
                userId: zod.string().optional(),
                filename: zod.string(),
                filesize: zod.number().or(zod.null()).optional(),
                url: zod.string().or(zod.null()).optional(),
                thumbnailUrl: zod.string().or(zod.null()).optional(),
                deleted: zod.boolean().optional(),
              })
              .strict(),
          )
          .or(zod.null())
          .optional(),
        evaluation: zod
          .object({
            kind: zod.string().optional(),
            dimensions: zod.record(
              zod.string(),
              zod
                .object({
                  level: zod.string().or(zod.null()).optional(),
                  comment: zod.string().or(zod.null()).optional(),
                  criteriaEvaluations: zod
                    .array(
                      zod
                        .object({
                          name: zod.string(),
                          met: zod.boolean(),
                        })
                        .strict(),
                    )
                    .or(zod.null())
                    .optional(),
                })
                .strict(),
            ),
          })
          .strict()
          .or(
            zod
              .object({
                kind: zod.string().optional(),
                subEvaluations: zod.record(
                  zod.string(),
                  zod
                    .object({
                      dimGrades: zod.record(
                        zod.string(),
                        zod
                          .object({
                            level: zod.string().or(zod.null()).optional(),
                            comment: zod.string().or(zod.null()).optional(),
                            criteriaEvaluations: zod
                              .array(
                                zod
                                  .object({
                                    name: zod.string(),
                                    met: zod.boolean(),
                                  })
                                  .strict(),
                              )
                              .or(zod.null())
                              .optional(),
                          })
                          .strict(),
                      ),
                      questionFeedback: zod.string().or(zod.null()).optional(),
                    })
                    .strict(),
                ),
                overallFeedback: zod
                  .object({
                    text: zod.string().or(zod.null()).optional(),
                    highlighting: zod
                      .record(
                        zod.string(),
                        zod.array(
                          zod
                            .object({
                              start: zod.string(),
                              end: zod.string(),
                            })
                            .strict(),
                        ),
                      )
                      .or(zod.null())
                      .optional(),
                  })
                  .strict()
                  .or(zod.null())
                  .optional(),
                promptVersion: zod.string().or(zod.null()).optional(),
              })
              .strict(),
          )
          .or(zod.null())
          .optional(),
        oralExamEvaluation: zod
          .object({
            subEvaluations: zod.array(
              zod
                .object({
                  id: zod.string(),
                  dimGrades: zod.record(
                    zod.string(),
                    zod
                      .object({
                        level: zod.string().or(zod.null()).optional(),
                        comment: zod.string().or(zod.null()).optional(),
                        criteriaEvaluations: zod
                          .array(
                            zod
                              .object({
                                name: zod.string(),
                                met: zod.boolean(),
                              })
                              .strict(),
                          )
                          .or(zod.null())
                          .optional(),
                      })
                      .strict(),
                  ),
                  questionFeedback: zod.string().or(zod.null()).optional(),
                })
                .strict(),
            ),
            overallFeedback: zod
              .object({
                text: zod.string().or(zod.null()).optional(),
                highlighting: zod
                  .record(
                    zod.string(),
                    zod.array(
                      zod
                        .object({
                          start: zod.string(),
                          end: zod.string(),
                        })
                        .strict(),
                    ),
                  )
                  .or(zod.null())
                  .optional(),
              })
              .strict()
              .or(zod.null())
              .optional(),
            promptVersion: zod.string().or(zod.null()).optional(),
          })
          .strict()
          .or(zod.null())
          .optional(),
        evaluationStudentFeedback: zod
          .object({
            isHelpful: zod.boolean(),
            reason: zod.string().or(zod.null()).optional(),
            category: zod
              .enum([
                'rephrased_my_work',
                'contradicted_earlier_advice',
                'focused_on_formatting_or_references',
                'score_changed_without_real_edit',
                'something_else',
              ])
              .or(zod.null())
              .optional(),
          })
          .strict()
          .or(zod.null())
          .optional(),
        evaluationFormativeFeedback: zod
          .object({
            detectedCurrentFocus: zod.string(),
            focusQualityAssessment: zod.enum(['acceptable', 'weak', 'unknown']),
            routingDecision: zod.enum(['stay', 'redirect']),
            targetDimension: zod.string(),
            observation: zod.string(),
            nextStep: zod.string(),
            isReadyToProgress: zod.boolean(),
          })
          .strict()
          .or(zod.null())
          .optional(),
        feedback: zod
          .object({
            text: zod.string().or(zod.null()).optional(),
            highlighting: zod
              .record(
                zod.string(),
                zod.array(
                  zod
                    .object({
                      start: zod.string(),
                      end: zod.string(),
                    })
                    .strict(),
                ),
              )
              .or(zod.null())
              .optional(),
          })
          .strict()
          .or(zod.null())
          .optional(),
        mcqResult: zod
          .object({
            score: zod.number().or(zod.null()).optional(),
            maxScore: zod.number().or(zod.null()).optional(),
            passed: zod.boolean().or(zod.null()).optional(),
            attempts: zod.number().optional(),
          })
          .strict()
          .or(zod.null())
          .optional(),
        oralExamSession: zod
          .object({
            selectedQuestionIds: zod.array(zod.string()).optional(),
            filledQuestions: zod.record(zod.string(), zod.string()).optional(),
            questions: zod
              .array(
                zod
                  .object({
                    id: zod.string(),
                    wording: zod.string().or(zod.null()).optional(),
                    startedAt: zod.string().datetime().or(zod.null()).optional(),
                    endedAt: zod.string().datetime().or(zod.null()).optional(),
                    transcriptHtml: zod.string().or(zod.null()).optional(),
                  })
                  .strict(),
              )
              .optional(),
          })
          .strict()
          .or(zod.null())
          .optional(),
        createdAt: zod.string().datetime().or(zod.null()).optional(),
        modifiedAt: zod.string().datetime().or(zod.null()).optional(),
        etag: zod.string().or(zod.null()).optional(),
        etagReconciledFromStaleClient: zod.boolean().or(zod.null()).optional(),
      })
      .strict()
      .or(zod.null())
      .optional(),
    message: zod.string().or(zod.null()).optional(),
    pagination: zod
      .object({
        total: zod.number(),
        page: zod.number(),
        pageSize: zod.number(),
      })
      .strict()
      .or(zod.null())
      .optional(),
    error: zod
      .object({
        code: zod.string(),
        message: zod.string(),
        details: zod.record(zod.string(), zod.any()).or(zod.null()).optional(),
      })
      .strict()
      .or(zod.null())
      .optional(),
    statusCode: zod.number().optional(),
  })
  .strict();

/**
 * Regenerate the unsigned module-level AI summary draft for manual grading.
 * @summary Regenerate Module Feedback
 */
export const regenerateModuleFeedbackParams = zod
  .object({
    user_id: zod.coerce.string(),
    course_id: zod.coerce.string(),
    module_id: zod.coerce.string(),
  })
  .strict();

export const regenerateModuleFeedbackResponseDataGradingConfigSnapshotEvalDimensionsMaxWeightMinOne = 0;
export const regenerateModuleFeedbackResponseDataGradingConfigSnapshotEvalDimensionsMaxWeightMaxOne = 1;
export const regenerateModuleFeedbackResponseDataGradingConfigSnapshotPerformanceLevelsItemPerformancePercentMin = 0;

export const regenerateModuleFeedbackResponseDataGradingConfigSnapshotPerformanceLevelsItemPerformancePercentMax = 1;
export const regenerateModuleFeedbackResponseDataGradingConfigSnapshotGradeProjectorFailAtMin = 0;

export const regenerateModuleFeedbackResponseDataGradingConfigSnapshotGradeProjectorFailAtMax = 1;
export const regenerateModuleFeedbackResponseDataGradingConfigSnapshotGradeProjectorTopAtMin = 0;

export const regenerateModuleFeedbackResponseDataGradingConfigSnapshotGradeProjectorTopAtMax = 1;
export const regenerateModuleFeedbackResponseDataGradingConfigSnapshotTaskGradeProjectorsFailAtMin = 0;

export const regenerateModuleFeedbackResponseDataGradingConfigSnapshotTaskGradeProjectorsFailAtMax = 1;
export const regenerateModuleFeedbackResponseDataGradingConfigSnapshotTaskGradeProjectorsTopAtMin = 0;

export const regenerateModuleFeedbackResponseDataGradingConfigSnapshotTaskGradeProjectorsTopAtMax = 1;

export const regenerateModuleFeedbackResponse = zod
  .object({
    data: zod
      .object({
        id: zod.string(),
        courseId: zod.string(),
        moduleId: zod.string(),
        moduleVersion: zod.string().or(zod.null()),
        studentId: zod.string(),
        studentName: zod.string(),
        state: zod.enum(['draft', 'processing', 'submitted', 'graded', 'aborted']),
        submittedAt: zod.string().datetime().or(zod.null()),
        gradedAt: zod.string().datetime().or(zod.null()),
        grading: zod
          .object({
            feedback: zod.string(),
            scoring: zod
              .object({
                scoringSchemaName: zod.string().or(zod.null()).optional(),
                scores: zod.record(zod.string(), zod.number()),
              })
              .strict()
              .or(zod.null())
              .optional(),
            grade: zod.number().or(zod.null()).optional(),
            manualGrade: zod.boolean().optional(),
            evaluatorId: zod.string().or(zod.null()).optional(),
          })
          .strict()
          .or(zod.null())
          .optional(),
        gradingConfigSnapshot: zod
          .object({
            evalDimensions: zod
              .record(
                zod.string(),
                zod
                  .object({
                    description: zod.string(),
                    systemManaged: zod.boolean().optional(),
                    maxWeight: zod
                      .number()
                      .min(regenerateModuleFeedbackResponseDataGradingConfigSnapshotEvalDimensionsMaxWeightMinOne)
                      .max(regenerateModuleFeedbackResponseDataGradingConfigSnapshotEvalDimensionsMaxWeightMaxOne)
                      .or(zod.null())
                      .optional(),
                  })
                  .strict(),
              )
              .optional(),
            performanceLevels: zod
              .array(
                zod
                  .object({
                    id: zod.string(),
                    performancePercent: zod
                      .number()
                      .min(
                        regenerateModuleFeedbackResponseDataGradingConfigSnapshotPerformanceLevelsItemPerformancePercentMin,
                      )
                      .max(
                        regenerateModuleFeedbackResponseDataGradingConfigSnapshotPerformanceLevelsItemPerformancePercentMax,
                      ),
                    label: zod.string(),
                    description: zod.string(),
                  })
                  .strict(),
              )
              .optional(),
            defaultFormalDimension: zod
              .object({
                name: zod.string(),
                max_pts: zod.number(),
                criteria: zod.array(
                  zod
                    .object({
                      name: zod.string(),
                      pts: zod.number(),
                      descriptor: zod.string(),
                      dimension_critical: zod.boolean().optional(),
                      active_when_all_positive: zod.array(zod.string()).optional(),
                    })
                    .strict(),
                ),
                params: zod.record(zod.string(), zod.any()).optional(),
                actual_max_pts: zod.number(),
              })
              .strict(),
            defaultFormalParams: zod
              .record(zod.string(), zod.record(zod.string(), zod.record(zod.string(), zod.any())))
              .or(zod.null())
              .optional(),
            gradeProjector: zod
              .object({
                type: zod.string().optional(),
              })
              .strict()
              .or(
                zod
                  .object({
                    type: zod.string().optional(),
                  })
                  .strict(),
              )
              .or(
                zod
                  .object({
                    type: zod.string().optional(),
                  })
                  .strict(),
              )
              .or(
                zod
                  .object({
                    type: zod.string().optional(),
                    failAt: zod
                      .number()
                      .min(regenerateModuleFeedbackResponseDataGradingConfigSnapshotGradeProjectorFailAtMin)
                      .max(regenerateModuleFeedbackResponseDataGradingConfigSnapshotGradeProjectorFailAtMax)
                      .optional(),
                    topAt: zod
                      .number()
                      .min(regenerateModuleFeedbackResponseDataGradingConfigSnapshotGradeProjectorTopAtMin)
                      .max(regenerateModuleFeedbackResponseDataGradingConfigSnapshotGradeProjectorTopAtMax)
                      .optional(),
                  })
                  .strict(),
              )
              .or(zod.null())
              .optional(),
            taskGradeProjectors: zod
              .record(
                zod.string(),
                zod
                  .object({
                    type: zod.string().optional(),
                  })
                  .strict()
                  .or(
                    zod
                      .object({
                        type: zod.string().optional(),
                      })
                      .strict(),
                  )
                  .or(
                    zod
                      .object({
                        type: zod.string().optional(),
                      })
                      .strict(),
                  )
                  .or(
                    zod
                      .object({
                        type: zod.string().optional(),
                        failAt: zod
                          .number()
                          .min(regenerateModuleFeedbackResponseDataGradingConfigSnapshotTaskGradeProjectorsFailAtMin)
                          .max(regenerateModuleFeedbackResponseDataGradingConfigSnapshotTaskGradeProjectorsFailAtMax)
                          .optional(),
                        topAt: zod
                          .number()
                          .min(regenerateModuleFeedbackResponseDataGradingConfigSnapshotTaskGradeProjectorsTopAtMin)
                          .max(regenerateModuleFeedbackResponseDataGradingConfigSnapshotTaskGradeProjectorsTopAtMax)
                          .optional(),
                      })
                      .strict(),
                  ),
              )
              .or(zod.null())
              .optional(),
          })
          .strict()
          .or(zod.null())
          .optional(),
      })
      .strict()
      .or(zod.null())
      .optional(),
    message: zod.string().or(zod.null()).optional(),
    pagination: zod
      .object({
        total: zod.number(),
        page: zod.number(),
        pageSize: zod.number(),
      })
      .strict()
      .or(zod.null())
      .optional(),
    error: zod
      .object({
        code: zod.string(),
        message: zod.string(),
        details: zod.record(zod.string(), zod.any()).or(zod.null()).optional(),
      })
      .strict()
      .or(zod.null())
      .optional(),
    statusCode: zod.number().optional(),
  })
  .strict();
